<template>
    <Card>
        <p slot="title">
            Cetak Ulang
        </p>
        <Row type="flex" justify="space-between" class="code-row-bg">
            <Col span="4">
                <Date-picker v-model="searchCreatedDate"
                    type="date"
                    placeholder="Tgl.Buat"
                    format="dd/MM/yyyy">
                </Date-picker>
            </Col>

            <Col span="4">
                <Select v-model="searchSelectDepartement"
                    clearable
                    placeholder="Dept. Item"
                    >
                    <Option v-for="dept, idx in departements" :value="dept.id" :key="idx">
                        {{ dept.deptName }}
                    </Option>
                </Select>
            </Col>
            <Col span="2">
                <Select
                    v-if="searchSelectSubbranch == 'JKT'"
                    v-model="searchSelectSubbranch"
                    disabled
                    placeholder="Branchcode"
                    @on-change="setMarkingCode"
                    >
                    <Option v-for="subbranch, idx in subbranchs" :value="subbranch.subbranchcode" :key="idx">
                        {{ subbranch.subbranchname }}
                    </Option>
                </Select>
                <Select
                    v-else
                    v-model="searchSelectSubbranch"
                    disabled
                    placeholder="Branchcode"
                    @on-change="setMarkingCode"
                    >
                    <Option v-for="subbranch, idx in subbranchs" :value="subbranch.subbranchcode" :key="idx">
                        {{ subbranch.subbranchname }}
                    </Option>
                </Select>

            </Col>

            <Col span="4">
                <Select
                    placeholder="Ketik Marking"
                    v-model="searchMarkingId"
                    filterable
                    clearable
                    remote
                    :remote-method="getMarkingByCode"
                    :loading="loadingGetMarking" >
                    <Option v-for="(option, index) in searchOptionMarkings"
                        :value="option.value" :key="index">{{option.label}}</Option>
                </Select>
            </Col>
            <Col span="4">
                <Button type="primary"
                    :loading="loadinggetRePrint"
                    icon="ios-search-strong"
                    @click="getRePrint">
                    <span v-if="!loadinggetRePrint">Cari Cetak Ulang</span>
                    <span v-else>Wait................</span>
                </Button>
            </Col>
        </Row>
        <br>
        <Alert v-show="kontras.length > 0" type="success">
            Found {{kontras.length}} Marking - {{printerServerIP}}
        </Alert>
        <br>
        <Row type="flex" justify="space-between" class="code-row-bg" v-show="kontras.length > 0">
            <Col span="5">
                <Date-picker v-model="backDate"
                    type="date"
                    placeholder="Tgl. Cetak (Back Date)"
                    format="dd/MM/yyyy">
                </Date-picker>
            </Col>
        </Row>
        <br>
        <Alert v-show="kontras.length > 0" type="warning" show-icon>
            Back Date masih proses penyesuaian
        </Alert>
        <br>
        <Table
            v-show="kontras.length > 0"
            :columns="tableColumn"
            :data="kontras"
            no-data-text=""></Table>
    </Card>
</template>

<script>
import {HTTP} from '@/components/http-lib'
import {SPARK} from '@/components/http-lib'

import pdfKontraRePrint from '@/components/kontra/pdfKontraRePrint'

import _ from 'lodash'
import moment from 'moment'
const numeral = require('numeral');

    export default {
        components : {
            pdfKontraRePrint
        },
        data () {
            return {
                kontras : [],
                kontrasProp : {},
                invoiceDate : '',
                departementId : '',
                departements : '',
                subbranchs: '',
                searchCreatedDate : '',
                backDate : '',
                searchSelectDepartement : '',
                searchSelectSubbranch : localStorage.getItem('user.subbranchcode'),
                searchMarkingId : '',
                searchOptionMarkings : '',
                loadingGetMarking : false,
                loadinggetRePrint : false,
                markingIdSelected : '',
                kontrasToShow : [],
                printerServerIP : localStorage.getItem('serverIP'),
                printer : {
                    printername : localStorage.getItem('printerName'),
                    printerIP : localStorage.getItem('printerIP')
                },
                tableColumn: [
                    {
                        type: 'index',
                        width: 60,
                        align: 'center'
                    },
                    {
                        title: 'markingcode',
                        key: 'markingcode',
                        sortable: true
                    },
                    {
                        title: 'create',
                        key: 'kontraCreatedAt',
                        sortable: true
                    },

                    {
                        type: 'html',
                        title: 'description',
                        key: 'description',
                        sortable: false
                    },
                    {
                        type: 'html',
                        title: 'Dept',
                        key: 'deptNames',
                        sortable: false
                    },
                    {
                        type: 'html',
                        title: 'loaddate',
                        key: 'loaddates',
                        sortable: false
                    },
                    {
                        type: 'html',
                        title: 'Total',
                        key: 'invoiceFees',
                        align: 'right',
                        sortable: false
                    },
                    {
                        title: 'Action',
                        key: 'printed',
                        width: 200,
                        align: 'center',
                        render: (h, params) => {
                            const row = params.row;
                            let classButton = row.printed == true ? 'ghost' : 'primary';
                            const text = row.printed == true ? 'Re Print' : 'Re Print';
                            const isSuccessPrinted = row.isSuccessPrinted;

                            if (!isSuccessPrinted) {
                                classButton = 'ivu-btn-error'
                            }
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: classButton,
                                        size: 'small'
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.doPrinting(params.index)
                                        }
                                    }
                                }, text),
                                // h('Button', {
                                //     props: {
                                //         type: 'error',
                                //         size: 'small'
                                //     },
                                //     style: {
                                //         marginRight: '5px'
                                //     },
                                //     on: {
                                //         click: () => {
                                //             this.exportFile(params.index)
                                //         }
                                //     }
                                // }, 'Pdf'),
                                // h('Button', {
                                //     props: {
                                //         type: 'success',
                                //         size: 'small'
                                //     },
                                //     on: {
                                //         click: () => {
                                //             this.exportFile(params.index)
                                //         }
                                //     }
                                // }, 'Excel')
                            ]);

                        }
                    }
                ]
            }
        },
        methods: {
            show (index) {
                console.log(this.kontras[index])
            },
            remove (index) {
                this.data6.splice(index, 1);
            },
            getRePrint: function(){
                this.loadinggetRePrint = true

                if(this.searchCreatedDate != ''){
                    this.searchCreatedDate = moment(this.searchCreatedDate).format('YYYY/MM/DD')
                }

              HTTP
                .post('kontra/rePrint', {
                    createdDate: this.searchCreatedDate ,
                    departementId: this.searchSelectDepartement || null,
                    markingHeaderId: this.searchMarkingId,
                    subbranchcode: this.searchSelectSubbranch || null
                })
                .then(response => {
                    console.log({response});
                  var formattedKontras = [];
                  _.forEach(response.data, function(value) {

                    if(value.kontras[0] != null)
                    {
                        let detailMarking  = value.kontras[0].invoices[0];
                        let markingcode = value.markingheadercode;

                        let markinginfoaddress1 = detailMarking.markinginfoaddress1;
                        let markinginfoaddress2 = detailMarking.markinginfoaddress2;
                        let markinginfophone1 = detailMarking.markinginfophone1;
                        let markinginfophone2 = detailMarking.markinginfophone2;
                        let markinginfoname = detailMarking.markinginfoname;


                        _.forEach(value.kontras, function(kontra) {
                            let kontraCreatedAt = moment(kontra.created_at).format('YYYY-MM-DD');

                            let invoiceFees = '';
                            let loaddates = '';
                            let deptNames= '';
                            let description = '';

                            let invoices = kontra.invoices;
                            let kontraid = kontra.kontraid;

                            _.forEach(invoices, function(invoice) {

                                // if(invoice.detail == null){
                                //     console.log(markingcode)
                                //     console.log(invoice)
                                // }

                                let containercode = invoice.detail.container.containercode;
                                let deptName = '';

                                if(invoice.deptName){
                                    deptName = invoice.deptName + '<br/>';
                                } else {
                                    deptName = 'None' + '<br/>';
                                }

                                let loaddate = moment(invoice.detail.container.loaddate).format('DD-MM-YYYY')+ '<br/>';

                                let subDescription = 'P. '+containercode +' <br/>';
                                description += subDescription;

                                let invoiceFee = numeral(invoice.invoicefee).format('0,0')+ '<br/>';
                                invoiceFees +=invoiceFee;
                                loaddates += loaddate;
                                deptNames += deptName;
                                console.log(invoice);
                            });


                            let kontraData = {
                                kontraid : kontraid,
                                kontraCreatedAt : kontraCreatedAt,
                                markingcode : markingcode,
                                markinginfoaddress1 : markinginfoaddress1,
                                markinginfoaddress2 : markinginfoaddress2,
                                markinginfophone1 : markinginfophone1,
                                markinginfophone2 : markinginfophone2,
                                markinginfoname : markinginfoname,
                                invoices : invoices,
                                loaddates : loaddates,
                                deptNames : deptNames,
                                invoiceFees : invoiceFees,
                                description : description,
                                printed : false,
                                isSuccessPrinted : true,
                                printer : localStorage.getItem('printerName'),
                                serverAPI : localStorage.getItem('serverIP'),
                            }

                            // formattedKontras = _.sortBy(formattedKontras, ['markingcode']);
                            formattedKontras = _.sortBy(formattedKontras, ['kontraCreatedAt']);

                            formattedKontras.push(kontraData);

                        });
                    }

                    console.log({formattedKontras});
                  });

                  this.kontras = formattedKontras;
                  this.kontrasToShow = formattedKontras;
                  this.loadinggetRePrint = false
                })
                .catch(e => {
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
            },
            doPrinting: function(index)
            {
                if(this.printer.printername == ''){
                    this.$Notice.error({
                        title: "Nama Printer Kosong",
                        desc: "Tambahkan nama printer pada menu Setting",
                        duration: 5
                    });
                    return false;
                }

                this.kontrasToShow[index].printed = true;
                this.kontrasToShow[index].backDate = moment(this.backDate).format('YYYY-MM-DD');
                let textToPrint = this.kontrasToShow[index];

                console.log(textToPrint);

                _.forEach(textToPrint.invoices, function(invoice) {
                  invoice.detail.invoiceFee = Math.round(parseFloat(invoice.detail.invoiceFee));
                });

                console.log(textToPrint)
                // console.log(SPARK)

                SPARK
                    .post('print', {
                        kontra: textToPrint
                    })
                    .then(response => {
                        this.kontrasToShow[index].isSuccessPrinted = true;
                        console.log(response.data)
                    })
                    .catch(e => {
                        this.kontrasToShow[index].isSuccessPrinted = false;
                        this.$Notice.error({
                            title: "Error Print",
                            desc: e + "<br/>Pastikan aplikasi printer sudah dinyalakan",
                            duration: 0
                        });
                    })


            },
            formattingKontra: function(textToPrint){
                let kontraFormatted = {
                    markingcode : textToPrint.markingcode,
                    kontraRow : kontraRow
                }
                return kontraFormatted;
            },
            getDepartement: function(){
                HTTP
                .get('itemDept')
                .then(response => {
                    this.departements = response.data
                })
                .catch(e => {
                    //console.log(e);
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
            },
            getSubbranch: function(){
                HTTP
                .get('subbranch')
                .then(response => {
                    this.subbranchs = response.data
                })
                .catch(e => {
                    //console.log(e);
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
            },
            setMarkingCode: function(){
                this.searchMarkingId = ''
            },
            getMarkingByCode: _.debounce(
                function (query) {
                    if (query !== '') {
                        this.loadingGetMarking = true;

                        HTTP
                        .post('marking/getBySnapshot', {
                            markingHeaderId: query,
                            subbranchcode: this.searchSelectSubbranch || null

                        })
                        .then(response => {
                            this.loadingGetMarking = false;
                            let data = response.data;

                            const list = data.map(item => {
                                return {
                                    value: item.markingheaderid,
                                    label: item.markingheadercode
                                };
                            });

                            this.searchOptionMarkings = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
                            console.log(this.searchOptionMarkings[0]);
                        })
                        .catch(e => {
                            this.$Notice.error({
                                title: "Error",
                                desc: e,
                                duration: 5
                            });
                        })
                    } else {
                        this.searchOptionMarkings = [];
                    }
                }, 400
            ),
            compareDates: function(d1, d2) {
                // .getTime() akan menghasilkan nilai bernilai integer dalam bentuk milisecond
                let compareDate1 = new Date(d1).getTime();
                let compareDate2 = new Date(d2).getTime();

                if (compareDate1 < compareDate2) {
                    return compareDate2
                } else if (compareDate1 > compareDate2) {
                    return compareDate1
                } else {
                    return compareDate2
                }
            },
            countDifferenceDay: function(d1, d2) {
                // variabel miliday sebagai pembagi untuk menghasilkan hari
                let miliday = 24 * 60 * 60 * 1000;

                // .getTime() akan menghasilkan nilai bernilai integer dalam bentuk milisecond
                let countDiffDate1 = new Date(d1).getTime();
                let countDiffDate2 = new Date(d2).getTime();

                let diffDay = (countDiffDate2 - countDiffDate1) / miliday;

                return diffDay;
            },
            exportFile: function(index) {
                let parent = this
                let dueDateDay = 0
                let lastInvoicedateDue = 0
                let grandTotal = 0

                parent.kontrasProp = parent.kontrasToShow[index]

                // get last invoicedatedue & count difference day (invoicedatedue - invoiceDate)
                _.forEach(parent.kontrasProp.invoices, function(invoice) {
                    dueDateDay = parent.countDifferenceDay(invoice.detail.invoiceDate, invoice.detail.invoicedatedue);
                    lastInvoicedateDue = parent.compareDates(lastInvoicedateDue, invoice.detail.invoicedatedue);
                    grandTotal += invoice.invoicefee

                    if(invoice.detail.mainFees[0].item.length > 22) {
                      invoice.detail.mainFees[0].item = invoice.detail.mainFees[0].item.substring(0, 22) + "...";
                    }
                });

                parent.kontrasProp.dueDateDay = dueDateDay
                parent.kontrasProp.lastInvoicedateDue = moment(lastInvoicedateDue).format('YYYY-MM-DD')
                parent.kontrasProp.grandTotal = grandTotal

                localStorage.setItem('kontrasProp', JSON.stringify(this.kontrasProp))
                window.open('#/kontra/pdfKontraRePrint', '_blank');
            },
        },
        created() {
            this.getDepartement();
            this.getSubbranch();
        }
    }
</script>



// WEBPACK FOOTER //
// KontraRePrint.vue?671d06dc